import { render } from "./NewUserView.vue?vue&type=template&id=ada4742c"
import script from "./NewUserView.vue?vue&type=script&lang=js"
export * from "./NewUserView.vue?vue&type=script&lang=js"

import "./NewUserView.vue?vue&type=style&index=0&id=ada4742c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__